<form [formGroup]="leningenFG">
    <div *ngIf="leningen.length > 0">
        <div formArrayName="leningen">
            <div *ngFor="let item of leningen.controls; let i = index"
                 [formGroupName]="i">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Omschrijving' : ''"
                                                    class="custom-input-225"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"
                                                    name="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                    class="custom-input-175"
                                                    formControlName="rekeningNummer"
                                                    id="rekeningNummer"
                                                    name="rekeningNummer"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Hoofdsom 1-1' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="hoofdsom0101"
                                                      id="hoofdsom0101"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Hoofdsom 31-12' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="hoofdsom3112"
                                                      id="hoofdsom3112"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Betaalde rente' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="rente"
                                                      id="rente"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      [label]="i === 0 ? 'Geldverstrekker' : ''"
                                                      [options]="soortLeningGeldVerstrekker"
                                                      [required]=true
                                                      class="custom-input-175"
                                                      formControlName="geldVerstrekker"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [label]="i === 0 ? '% box 1' : ''"
                                                      [showAllDecimals]="true"
                                                      align="right"
                                                      class="custom-input-125"
                                                      formControlName="percentageBox1"
                                                      id="percentageBox1"
                                                      postfix="%"
                                                      [maxValue]="100"
                    >
                    </snelstart-ui-number-form-control>
                    <div class="row col-auto">
                        <snelstart-ui-button (change)="saveForm()"
                                             (click)="deleteLening(i)"
                                             [class]="i === 0 ? 'firstrowbutton' : ''"
                                             class="delete"
                                             icon="trash"
                                             id="buttonDelete"
                                             size="medium"
                                             type="secondary"
                        >
                        </snelstart-ui-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="leningen.length === 0">
        <snelstart-ui-button (click)="addLening()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Lening invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="leningen.length > 0">
        <snelstart-ui-button (click)="addLening()" class="snelstart-ui-button pb-3 " icon="plus"
                             type="link">Lening toevoegen
        </snelstart-ui-button>
    </div>

    <div *ngFor="let item of leningen.controls; let i = index">
        <div *ngIf="item.value.geldVerstrekker === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE"
             class="mb-2 mt-3">
            <div *ngIf="isFirstNietAdminPlichtige(i)" class="pb-1">
                Vul de informatie over de geldverstrekker in!
            </div>
            <snelstart-ui-button
                    (click)="this.showDialog(i)"
                    icon="plus"
                    type="primary">
                Specificatie geldverstrekker {{ i + 1 }}
                : {{ item.value.omschrijving || item.value.rekeningNummer || 'geen omschrijving' }}
            </snelstart-ui-button>

        </div>
    </div>
</form>

<div *ngIf="hasPercentageBox1LessThan100()" style="width: 75%">
    <div class="space20"></div>
    <snelstart-ui-alert type="info">
        <b>Let op!</b> <br>
        Er is ingevuld dat een van de leningen gedeeltelijk in box 1 valt. Het deel van de hoofdsom per 1 januari dat
        niet in box 1 zit, is automatisch verwerkt als schuld in het vermogen (box 3). Is dat niet juist? Pas de
        gegevens dan aan bij de schulden in box 3. <br/>
        Zorg er dan wel voor dat je hier voor de hoofdsommen (1 januari en 31 december) en de betaalde rente 'gewoon'
        100% van de bedragen ingevuld hebt. Voor de berekeningen wordt de betaalde rente dan automatisch naar rato
        meegenomen als rente eigen woning.
    </snelstart-ui-alert>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="leningBijzonderheden" size="xl"
                                title="Gegevens lening en -verstrekker">
    <snelstart-ui-dialog-body>
        <form [formGroup]="leningenFG">
            <div formArrayName="leningen">
                <div *ngFor="let lening of leningen.controls; let i = index; "
                     [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div *ngIf="leningen.controls[i].get('geldVerstrekker')?.getRawValue() === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE"
                             class="row">
                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            class="custom-input-200 col-auto"
                                                            formControlName="aanvangsDatum"
                                                            id="aanvangsDatum"
                                                            label="Aanvangsdatum lening"
                                                            placeholder="dd-mm-jjjj"
                            >
                            </snelstart-ui-date-form-control>
                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            class="custom-input-200"
                                                            formControlName="eindDatum"
                                                            id="eindDatum"
                                                            label="Einddatum lening"
                                                            placeholder="dd-mm-jjjj"
                            >
                            </snelstart-ui-date-form-control>

                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              align="right"
                                                              class="custom-input-200 col-auto"
                                                              formControlName="oorspronkelijkeHoofdsom"
                                                              id="oorspronkelijkeHoofdsom"
                                                              label="Oorspronkelijke hoofdsom"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-select-form-control (change)="saveForm()"
                                                              [options]="soortLeningAflossingsMethode"
                                                              class="custom-input-200 col-auto"
                                                              formControlName="aflossingsMethode"
                                                              label="Aflossingsmethode lening"
                            >
                            </snelstart-ui-select-form-control>

                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              align="right"
                                                              class="custom-input-200 col-auto"
                                                              formControlName="rentePercentageDecimalen"
                                                              id="rentePercentageDecimalen"
                                                              label="Rentepercentage"
                                                              prefix="%"
                            >
                            </snelstart-ui-number-form-control>


                            <div class="space20"></div>

                            <div *ngIf="isAanvangsdatumNa2012(leningen.controls[i].get('aanvangsDatum')?.value)">
                                <snelstart-ui-alert type="info">
                                    Let op! Bij een lening die is afgesloten na 2012 dan gelden er speciale regels
                                    de aftrekbaarheid van de rente. <br/>Meer informatie vind je op de

                                    <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/koopwoning/content/renteaftrek-hypotheek-lening-eigen-woning-familie-bv-buitenlandse-bank"
                                       target="_blank">
                                        website van de Belastingdienst.</a>

                                </snelstart-ui-alert>

                                <div class="space20"></div>
                            </div>

                            <p><b>Gegevens leningverstrekker</b></p>

                            <div class="row" formGroupName="naamLeninggever">
                                <snelstart-ui-text-form-control (change)="saveForm()"
                                                                class="custom-input-265 col-auto"
                                                                formControlName="achternaam"
                                                                id="achternaam"
                                                                label="Naam"
                                >
                                </snelstart-ui-text-form-control>
                                <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                               class="me-1 custom-input-200 col-auto"
                                                               formControlName="bsn"
                                                               id="bsn"
                                                               label="BSN/RSIN"
                                >
                                </snelstart-ui-bsn-form-control>
                                <snelstart-ui-date-form-control (change)="saveForm()"
                                                                class="me-1 custom-input-200 col-auto"
                                                                formControlName="geboortedatum"
                                                                id="geboortedatum"
                                                                label="Geboortedatum (optioneel)"
                                                                placeholder="dd-mm-jjjj"
                                >
                                </snelstart-ui-date-form-control>
                            </div>
                        </div>

                        <div class="space20"></div>

                        <p><b>Adresgegevens</b></p>

                        <div class="row" formGroupName="adresLeninggever">
                            <snelstart-ui-text-form-control (change)="saveForm()"
                                                            class="me-1 custom-input-100 col-auto"
                                                            formControlName="postcode"
                                                            id="postcode"
                                                            label="Postcode"
                            >
                            </snelstart-ui-text-form-control>
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              class="me-1 custom-input-75 col-auto"
                                                              formControlName="huisNummer"
                                                              id="huisNummer"
                                                              label="Huisnr"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-text-form-control (change)="saveForm()"
                                                            class="me-1 custom-input-65 col-auto"
                                                            formControlName="huisNummerToevoeging"
                                                            id="huisNummerToevoeging"
                                                            label="Toev."
                            >
                            </snelstart-ui-text-form-control>
                            <snelstart-ui-text-form-control (change)="saveForm()"
                                                            class="me-1 custom-input-200 col-auto"
                                                            formControlName="woonplaats"
                                                            id="woonplaats"
                                                            label="Woon-/Vestigingsplaats"
                            >
                            </snelstart-ui-text-form-control>
                            <snelstart-ui-select-form-control (change)="saveForm()"
                                                              [options]="optionsLandcodes"
                                                              class="me-1 custom-input-200 col-auto"
                                                              formControlName="landCode"
                                                              label="Woon-/Vestigingsland"
                            >
                            </snelstart-ui-select-form-control>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button [disabled]="!isCurrentLeningValid" icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
